import React, { forwardRef } from 'react';
import { ScrollView, type ScrollViewProps, type ViewStyle } from 'react-native';
import { layoutLtrStyle } from '../../shared/i18n/rtl';

/**
 * Chronological / index-stable horizontal strip.
 * Always LTR layout + scroll offsets (first item = left, scrollTo x grows rightward),
 * including when the app shell is RTL. Labels/digits stay locale-aware in children.
 */
const CHRONOLOGICAL_LTR: ViewStyle = {
  ...layoutLtrStyle,
};

const CHRONOLOGICAL_LTR_CONTENT: ViewStyle = {
  ...layoutLtrStyle,
  flexDirection: 'row',
};

export const HorizontalLtrScrollView = forwardRef<ScrollView, ScrollViewProps>(function HorizontalLtrScrollView(
  { style, contentContainerStyle, horizontal = true, removeClippedSubviews, ...rest },
  ref,
) {
  return (
    <ScrollView
      ref={ref}
      horizontal={horizontal}
      style={horizontal ? [CHRONOLOGICAL_LTR, style] : style}
      contentContainerStyle={horizontal ? [CHRONOLOGICAL_LTR_CONTENT, contentContainerStyle] : contentContainerStyle}
      // Clipping + RTL native scroll has historically blanked / jittered horizontal strips.
      removeClippedSubviews={removeClippedSubviews ?? false}
      {...rest}
    />
  );
});
